// Tab component to display individual tab
const MachineTab = ({ label, isActive, onClick }) => {
    return (
      <div
        onClick={onClick}
        className={`tab ${isActive ? 'active' : ''}`}
        style={{
          padding: '10px 20px',
          cursor: 'pointer',
          borderLeft: '1px solid #ccc',
          borderRight: '1px solid #ccc',
          borderTop: isActive ? '2px solid green' : 'none',
          color: isActive ? 'green' : 'grey',
          transition: 'border-bottom 0.3s',
          fontWeight: isActive ? "bold" : '400',
        }}
      >
        {label}
      </div>
    );
  };

  export default MachineTab;